import React, { Component } from "react";
import Hero from './../../alpineComponents/hero';
import CenteredParagraph from './../../alpineComponents/centeredParagraph';
import { Link } from "react-router-dom";
import CheckmarkRow from './../../alpineComponents/checkmarkRow';
import  './../../utils/analytics';
import PaymentInfo from './../../components/paymentInfo';

export default class extends Component {
  render() {
    return (
		<div className="light-grey-background">
      <Hero
				title={'Services & Rates'}
				backgroundImage={'images/services-hero.jpg'}
				height={'threequarter'} /*full, half,threequarter*/
        subtitlePosition={'bottom'}
        tint={'dark'}
      />
      <div className="section-padding">
        <div className="max-width-container">
          <div className="row">
            <div className="small-12 medium-12 tiny-padding">
              <div className="small-padding primary-background shadow full-height relative anchor-padding centered-text">
                <h2 className="white">{'$99'}</h2>
                <h5 className="white">{'Introductory private session'}</h5>
                <p className="white">{'First one-on-one session for new clients only'}</p>
                <Link to="/contact">
                  <h6 className="button" style={{backgroundColor:'#fff',color:"#ee6725", marginTop:'40px'}}>{'Schedule'}</h6>
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="small-12 medium-6 tiny-padding">
              <div className="small-padding white-background shadow full-height relative">
                <h4>{'Private Sessions - 50 min'}</h4>
                <ul>
                  <li><b className="primary-color">{'$130'}</b><span  className="subheading">{' when purchased in pack of 10 ($1300)'}</span></li>
                  <li><b className="primary-color">{'$135'}</b><span  className="subheading">{' when purchased in pack of five ($675)'}</span></li>
                  <li><b className="primary-color">{'$145'}</b><span  className="subheading">{' single class'}</span></li>
                </ul>
                <Link to="/contact">
                  <h6 className="button" style={{backgroundColor:'#ee6725',color:"#fff", marginTop:'30px'}}>{'Schedule'}</h6>
                </Link>
                <p className="subheading" style={{marginTop:'30px'}}><i>{'Private sesssions are one on one, 50 minutes.'}</i></p>
              </div>
            </div>
            <div className="small-12 medium-6 tiny-padding">
              <div className="small-padding white-background shadow full-height relative">
                <h4>{'Duet Sessions - 50 min'}</h4>
                <ul>
                  <li><b className="primary-color">{'$85'}</b><span  className="subheading">{' per person per class'}</span></li>
                </ul>
                <Link to="/contact">
                  <h6 className="button" style={{backgroundColor:'#ee6725',color:"#fff", marginTop:'30px'}}>{'Schedule'}</h6>
                </Link>
                <p className="subheading" style={{marginTop:'30px'}}><i>{'Duet sessions are two students to one teacher, 50 minutes.'}</i></p>
              </div>
            </div>
          </div>
          <div className="small-padding">
            <div className="small-padding centered-text">
              <p className="subheading" style={{marginBottom:'20px'}}>We accept checks. Credit card and online payments must be approved by instructor and will incur a processing fee.   </p>
              <p className="subheading">Prices listed are for studio owner, Nancy Chin, only.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/services/index.js